export default {
  title: 'HLR',

  labels: {
    search: 'Введите номер телефона',
    status: 'Статус поиска'
  }
}
